module.exports = __webpack_public_path__ + "static/img/index_numBg06.a06bc2a0.png";